export default __webpack_public_path__ + "static/media/transaction-stack.8f40c8e7.png";